import React, {useMemo} from "react";
import {Tooltip} from "@mui/material";

const MediumTernaryColor = ({themes, selectedThemeId, name}) => {
    const color = useMemo(() => (
        themes?.find(e => e.id === selectedThemeId)?.values?.find(e => e.colorName === name)?.value
    ), [themes, selectedThemeId, name])

    return (
        <>
            <Tooltip followCursor title={`Ternary Color ${color}`}>
                <div className={'theme-ternary-color'}>
                    <div style={{'--theme-ternary-color': color}}/>
                </div>
            </Tooltip>
        </>
    );

}

export default MediumTernaryColor;
